import { render, staticRenderFns } from "./protocol-page.vue?vue&type=template&id=52a994bb&scoped=true"
import script from "./protocol-page.vue?vue&type=script&lang=js"
export * from "./protocol-page.vue?vue&type=script&lang=js"
import style0 from "./protocol-page.vue?vue&type=style&index=0&id=52a994bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a994bb",
  null
  
)

export default component.exports